import { combinedApi as api } from '@redux/combinedApi';
export const addTagTypes = ['TrendJob'] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      postTrendJobSubmit: build.mutation<PostTrendJobSubmitApiResponse, PostTrendJobSubmitApiArg>({
        query: (queryArg) => ({ url: `/TrendJob/submit`, method: 'POST', body: queryArg }),
        invalidatesTags: ['TrendJob'],
      }),
      getTrendJobById: build.query<GetTrendJobByIdApiResponse, GetTrendJobByIdApiArg>({
        query: (queryArg) => ({ url: `/TrendJob/${queryArg}` }),
        providesTags: ['TrendJob'],
      }),
      deleteTrendJobById: build.mutation<DeleteTrendJobByIdApiResponse, DeleteTrendJobByIdApiArg>({
        query: (queryArg) => ({ url: `/TrendJob/${queryArg}`, method: 'DELETE' }),
        invalidatesTags: ['TrendJob'],
      }),
      getTrendJobGetAll: build.query<GetTrendJobGetAllApiResponse, GetTrendJobGetAllApiArg>({
        query: () => ({ url: `/TrendJob/get-all` }),
        providesTags: ['TrendJob'],
      }),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as trendJobApi };
export type PostTrendJobSubmitApiResponse = unknown;
export type PostTrendJobSubmitApiArg = ApiApplicationServicesDataTypesTrendTypesNewTrendJob;
export type GetTrendJobByIdApiResponse =
  /** status 200 OK */ ApiCommonResponsesBaseCrudResponse601ApiCommonExternalDtoTrendJobExternalDto;
export type GetTrendJobByIdApiArg = number;
export type DeleteTrendJobByIdApiResponse = unknown;
export type DeleteTrendJobByIdApiArg = number;
export type GetTrendJobGetAllApiResponse =
  /** status 200 OK */ ApiCommonResponsesBaseCrudResponse601ApiCommonExternalDtoTrendJobExternalDto;
export type GetTrendJobGetAllApiArg = void;
export type ApiApplicationServicesDataTypesTrendTypesNewTrendJob = {
  name?: string | null;
  start?: string;
  end?: string;
  measurementParameterIds?: number[] | null;
  measurementDeviceIds?: number[] | null;
};
export type ApiDatabaseCommonTrendJobStatus = 0 | 1 | 2 | 3;
export type ApiCommonExternalDtoTrendJobExternalDto = {
  id?: number;
  name: string;
  start: string;
  end: string;
  creationDate: string;
  status: ApiDatabaseCommonTrendJobStatus;
  measurementDeviceIds: number[];
  measurementParameterIds: number[];
};
export type ApiCommonResponsesBaseCrudResponse601ApiCommonExternalDtoTrendJobExternalDto = {
  externalDto?: ApiCommonExternalDtoTrendJobExternalDto;
  externalDtos?: ApiCommonExternalDtoTrendJobExternalDto[] | null;
};
export const {
  usePostTrendJobSubmitMutation,
  useGetTrendJobByIdQuery,
  useLazyGetTrendJobByIdQuery,
  useDeleteTrendJobByIdMutation,
  useGetTrendJobGetAllQuery,
  useLazyGetTrendJobGetAllQuery,
} = injectedRtkApi;
